import { useMemo } from 'react';

export default function useLimit(): number {
  return useMemo(() => {
    if (
      'matchMedia' in window &&
      window.matchMedia('(min-width: 768px)').matches
    ) {
      return 6;
    }

    return 4;
  }, []);
}
